// services/loadsheddingService.js
import api from "./api";

export const getAllLoadsheddings = async (schemaName = null) => {
  try {
    const response = await api.get("/loadsheddings/", {
      params: schemaName ? { client: schemaName } : {},
    });
    console.log("Loadsheddings fetched:", response.data, "for schema:", schemaName);
    return response.data;
  } catch (error) {
    console.error("Error fetching loadsheddings:", error);
    throw error;
  }
};

export const getLoadsheddingById = async (id, schemaName = null) => {
  try {
    const response = await api.get(`/loadsheddings/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching loadshedding with ID ${id}:`, error);
    throw error;
  }
};

export const createLoadshedding = async (loadsheddingData, schemaName = null) => {
  try {
    const response = await api.post("/loadsheddings/", loadsheddingData, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error("Error creating loadshedding:", error);
    throw error;
  }
};

export const updateLoadshedding = async (id, loadsheddingData, schemaName = null) => {
  try {
    const response = await api.put(`/loadsheddings/${id}/`, loadsheddingData, {
      params: schemaName ? { client: schemaName } : {},
    });
    return response.data;
  } catch (error) {
    console.error(`Error updating loadshedding with ID ${id}:`, error);
    throw error;
  }
};

export const deleteLoadshedding = async (id, schemaName = null) => {
  try {
    await api.delete(`/loadsheddings/${id}/`, {
      params: schemaName ? { client: schemaName } : {},
    });
  } catch (error) {
    console.error(`Error deleting loadshedding with ID ${id}:`, error);
    throw error;
  }
};

// Optional: Add pagination support
export const getLoadsheddingsWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  startDate = "",
  endDate = "",
  ordering = "-created_at",
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    if (startDate) params.append("start_date", startDate);
    if (endDate) params.append("end_date", endDate);

    const response = await api.get("/loadsheddings/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching loadsheddings with pagination:", error);
    throw error;
  }
};

// Optional: Add schedule-related functions
export const getCurrentLoadsheddingSchedule = async () => {
  try {
    const response = await api.get("/loadsheddings/current/");
    return response.data;
  } catch (error) {
    console.error("Error fetching current loadshedding schedule:", error);
    throw error;
  }
};

export const getLoadsheddingForecast = async (days = 7) => {
  try {
    const response = await api.get("/loadsheddings/forecast/", {
      params: { days },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching loadshedding forecast:", error);
    throw error;
  }
};

// Optional: Add status check function
export const getLoadsheddingStatus = async () => {
  try {
    const response = await api.get("/loadsheddings/status/");
    return response.data;
  } catch (error) {
    console.error("Error fetching loadshedding status:", error);
    throw error;
  }
};
